import {Link} from 'react-router-dom';
import {Navbar} from '@common/ui/navigation/navbar/navbar';
import {Footer} from '@common/ui/footer/footer';
import {useSettings} from '@common/core/settings/use-settings';
import {LaunchOfferBanner} from '@app/landing/launch-offer-banner';
import {PageSeo} from '@app/landing/page-seo';
import {currentYear} from '@app/landing/replace-year';
import {getCategoryLabel, getUseCasesByCategory} from './use-case-page-data';
import '../landing-page.css';

export function UseCasesHubPage() {
  const {branding, base_url} = useSettings();
  const grouped = getUseCasesByCategory();
  const siteName = branding?.site_name || 'LinkInBio';
  const pageUrl = `${(base_url || '').replace(/\/$/, '')}/for`;

  return (
    <div className="min-h-screen flex flex-col bg-white">
      <PageSeo
        title={`Free Link in Bio Guides for Creators ${currentYear()} | LinkInBio`}
        description={`Find the ${siteName} guide built for your niche — fitness creators, musicians, real estate agents, and 50+ other creators and businesses.`}
        url={pageUrl}
      />
      <Navbar
        color="bg"
        border="border-b"
        className="lp-sticky-nav"
        menuPosition="homepage-navbar"
      />

      <main className="flex-auto">
        <header className="pt-80 md:pt-100 pb-40">
          <div className="landing-container max-w-[900px] text-center">
            <LaunchOfferBanner className="mb-24 inline-block" />
            <span className="section-label">LINK IN BIO FOR</span>
            <h1 className="alt-heading mb-16">
              {siteName} for every creator &amp; business
            </h1>
            <p className="text-base text-muted max-w-[700px] mx-auto">
              Find the guide built for your niche — with feature
              recommendations, FAQs, and tips tailored to how you actually
              work.
            </p>
          </div>
        </header>

        <section className="pb-80 md:pb-100">
          <div className="landing-container max-w-[1000px]">
            {grouped.map(([category, useCases]) => (
              <div key={category} className="mb-56">
                <h2 className="font-bold text-lg mb-20">
                  {getCategoryLabel(category)}
                </h2>
                <div className="grid sm:grid-cols-2 md:grid-cols-3 gap-16">
                  {useCases.map(useCase => (
                    <Link
                      key={useCase.slug}
                      to={`/for/${useCase.slug}`}
                      className="rounded-xl border px-20 py-16 text-sm font-medium hover:border-primary hover:bg-primary/5 transition-colors"
                    >
                      {useCase.name}
                    </Link>
                  ))}
                </div>
              </div>
            ))}
          </div>
        </section>
      </main>

      <Footer className="mx-14 md:mx-40" />
    </div>
  );
}
